<template>
    <section class="section-conversation">
        <header>
            <span class="conversationTitle" v-if="conversation">
                {{ conversation.fullname }} {{ $t("chatbotv2.withBot") }}
            </span>
            <span class="conversationTitle" v-else>{{ $t("chatbotv2.userWithBot") }}</span>
        </header>
        <div class="archives-conversation">
            <div class="conversation" style="background: rgb(255, 255, 255)">
                <MessageList
                    v-if="conversation && getMessages().length && conversation._id !== null"
                    :always-scroll-to-bottom="false"
                    :colors="colors"
                    :messages="getMessages()"
                    :participants="getParticipants()"
                    :scroll-top="true"
                />
            </div>
        </div>
    </section>
</template>

<script>
import * as _ from "lodash";
import moment from "moment";
import { mapActions, mapState } from "vuex";
import { toNewMessagesModel } from "../../../../../utils/chat";
import MessageList from "../../../../../components/popup-chat/MessageList";
import log2 from "../../../../../utils/log2";

const log = log2("ConversationViewer");
export default {
    name: "ConversationViewer",
    components: {
        MessageList,
    },
    props: {
        conversation: {
            required: true,
        },
        skeletonLoading: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            messages: [],
            loading: true,
            colors: {
                header: {
                    bg: "#4e8cff",
                    text: "#ffffff",
                },
                launcher: {
                    bg: "#4e8cff",
                },
                messageList: {
                    bg: "#ffffff",
                },
                sentMessage: {
                    bg: "#4e8cff",
                    text: "#ffffff",
                },
                receivedMessage: {
                    bg: "#eaeaea",
                    text: "#222222",
                },
                userInput: {
                    bg: "#f4f7f9",
                    text: "#565867",
                },
            },
        };
    },
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
        }),
    },
    methods: {
        ...mapActions({
            loadOldMessages: "chat/loadOldMessages",
            getUser: "user/getUser",
            getUsers: "user/getUsers",
        }),
        fetchMessages() {
            if (!this.conversation) return;
            this.loading = true;
            this.loadOldMessages(this.conversation._id)
                .then((response) => {
                    this.isLoading = false;
                    let items = response.data.data;
                    items = _.orderBy(
                        _.uniqBy(items, (q) => q._id || q.uniqMessageId),
                        (q) => moment(q.createdDate).toDate().getTime(),
                        "asc"
                    );
                    this.messages = items.filter((m) => "undefined" === typeof m.type);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        getMessages() {
            return toNewMessagesModel(this.messages, this);
        },
        fetchAllUsers() {
            this.getUsers({ perPage: 1000, page: 1 }).then((response) => {
                log("getUsers completed", response.data);
            });
        },
        getParticipants() {
            const supportUsers = this.messages
                .filter((x) => x.messageType === "user" || x.messageType === "private")
                .map((x) => ({
                    id: x.userId,
                    name: x.username,
                }));

            return _.uniqBy(supportUsers, (q) => q.name);
        },
    },
    mounted() {
        log("mounted");
        this.fetchAllUsers();
        this.fetchMessages();
    },
    watch: {
        conversation: {
            handler(newVal, oldVal) {
                const newId = _.get(newVal, "_id");
                const oldId = _.get(oldVal, "_id");
                if (newId !== oldId) {
                    this.fetchMessages();
                }
            },
            deep: true,
        },
    },
};
</script>

<style scoped></style>
